/* ---------- swiper testimonials ---------- */
var mySwiper = new Swiper(".testi_swiper", {
  wrapperClass: "testi_swiper-list",
  slideClass: "testi_swiper-item-wrap",
  watchOverflow: true,
  slidesPerView: 1,
  allowTouchMove: false,
  loop: true,
  spaceBetween: 0,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  lazy: false,
  keyboard: {
    enabled: true,
  },
  navigation: {
    nextEl: "#swiper-right",
    prevEl: "#swiper-left",
  },
  speed: 600,
});

// Get all elements with class .testi_bullet
var bullets = document.querySelectorAll(".testi_bullet");

// Function to update active bullet
function updateActiveBullet(index) {
  // Remove the class from all bullets
  bullets.forEach(function (b) {
    b.classList.remove("is-active-bullet");
  });

  // Add the class to the corresponding bullet
  bullets[index].classList.add("is-active-bullet");
}

// Add click event listener to each .testi_bullet element
bullets.forEach(function (bullet, index) {
  bullet.addEventListener("click", function () {
    // Slide to the corresponding index
    mySwiper.slideToLoop(index); // Use slideToLoop instead of slideTo

    // Update active bullet
    updateActiveBullet(index);
  });
});

// Add event listener to Swiper navigation next button
document.querySelector("#swiper-right").addEventListener("click", function () {
  // Get the index of the active slide
  var activeIndex = mySwiper.realIndex; // Use realIndex instead of activeIndex

  // Update active bullet
  updateActiveBullet(activeIndex);
});

// Add event listener to Swiper navigation prev button
document.querySelector("#swiper-left").addEventListener("click", function () {
  // Get the index of the active slide
  var activeIndex = mySwiper.realIndex; // Use realIndex instead of activeIndex

  // Update active bullet
  updateActiveBullet(activeIndex);
});
